import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";

import { AgGridModule } from "ag-grid-angular";
import { NgxSpinnerModule } from "ngx-spinner";
import { BadgeModule } from "primeng/badge";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CheckboxModule } from "primeng/checkbox";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DropdownModule } from "primeng/dropdown";
import { InputMaskModule } from "primeng/inputmask";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ToastModule } from "primeng/toast";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";

import { AuthGuardService } from "../services/auth-guard.service";
import { EmployeeActionComponent } from "./employee-action.component";
import { EmployeeActivityFormComponent } from "./employee-activity-form.component";
import { EmployeeFormComponent } from "./employee-form.component";
import { EmployeesComponent } from "./employees.component";
import { EmployeeTrainingRecordComponent } from "./employee-training-record.component";
import { InputNumberModule } from "primeng/inputnumber";
import { EmployeeTrainingRecordFormComponent } from "./employee-training-record-form.component";
import { EmployeeTrainingRecordWarningComponent } from "./employee-training-record-warning.component";
import { EmployeeHistoryComponent } from "./employee-history.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxSpinnerModule,
    AgGridModule.withComponents([]),

    BadgeModule,
    BreadcrumbModule,
    ButtonModule,
    CalendarModule,
    CheckboxModule,
    ConfirmDialogModule,
    DropdownModule,
    InputMaskModule,
    InputNumberModule,
    InputTextareaModule,
    InputTextModule,
    ToolbarModule,
    TooltipModule,
    ToastModule,

    RouterModule.forChild([
      { path: 'employees', component: EmployeesComponent, canActivate: [AuthGuardService] },
      { path: 'employee-training-record', component: EmployeeTrainingRecordComponent, canActivate: [AuthGuardService] },
    ])
  ],
  declarations: [
    EmployeeActionComponent,
    EmployeeActivityFormComponent,
    EmployeeFormComponent,
    EmployeesComponent,
    EmployeeTrainingRecordComponent,
    EmployeeTrainingRecordFormComponent,
    EmployeeTrainingRecordWarningComponent,
    EmployeeHistoryComponent
  ],
  exports:[
    EmployeeFormComponent
  ]
})
export class EmployeeModule{}